import Class from './legacy-class';

export const BottomItem = Class({
    should_appear_depends_on() {
        return ['capabilities', 'access'];
    },
    should_appear(device) {
        return false;
    },
});

export const BottomButton = Class(BottomItem, {
    element() {
        return this._element;
    },
});

export const BottomTab = Class(BottomItem, {
    destroy() {},

    element() {
        return this._element;
    },

    activated() {},
    deactivated() {},

    handleResize() {},
}).implement(
    Class.Properties({
        collapsed: {
            value: false,
        },
    })
);
